export default __webpack_public_path__ + "static/media/sisterhood-of-tech-logo.54a2919a.svg";